import { Chart, defaults } from 'chart.js';
import {
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
  ArcElement,
  DoughnutController,
} from 'chart.js';

export function registerChartDefaults(): void {
  Chart.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Tooltip,
    Legend,
    ArcElement,
    DoughnutController
  );

  defaults.font.family = 'Inter, sans-serif';
  defaults.responsive = true;
  defaults.maintainAspectRatio = false;
}
